import { HistoryItem, OptionsFormatDate } from '../../interfaces/interfaces';

const uploadHistoryHandler = (item: HistoryItem) => {
  const getId = () => item?.id;
  const getAndConvertTime = (time: string) => {
    const dateCreated = new Date(time);
    const options: OptionsFormatDate = { year: 'numeric', month: 'short', day: '2-digit' };
    const localDate = dateCreated.toLocaleDateString('en-GB', options).split(' ').reverse().join('/');
    const localTime = dateCreated.toLocaleTimeString('en-GB');
    return `${localDate} ${localTime}`;
  };
  const getTimeCreatedAt = () => getAndConvertTime(item.created_at);
  const getUserName = () => item?.user_name;
  const getFileType = () => item?.file_content?.file_type?.name;
  const getFileContent = () => item?.file_content?.name;
  const getFileSource = () => item?.file_content?.file_type?.source?.name;
  const getFileVersion = () => item?.file_version;
  const getTimeUpdatedAt = () => getAndConvertTime(item.updated_at);
  const getFileDataUrl = () => item.file_data.url;
  const getFileDataName = () => item.file_data.name;
  const getUploadHistoryStatus = () => {
    if (item.status === 'failed') return item.error;
    return item.status.split('_').join(' ');
  };

  return {
    getId,
    getTimeCreatedAt,
    getUserName,
    getFileType,
    getFileContent,
    getFileSource,
    getFileVersion,
    getTimeUpdatedAt,
    getFileDataUrl,
    getFileDataName,
    getUploadHistoryStatus,
  };
};

export default uploadHistoryHandler;
